const GOOGLE_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

let googleScriptPromise = null;

const loadGoogleScript = () => {
  if (window.google?.accounts?.oauth2) {
    return Promise.resolve();
  }

  if (!googleScriptPromise) {
    googleScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(`script[src="${GOOGLE_SCRIPT_SRC}"]`);

      if (existingScript) {
        existingScript.addEventListener("load", resolve, { once: true });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = GOOGLE_SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  return googleScriptPromise;
};

export const preloadGoogleAuth = () => {
  loadGoogleScript().catch((error) => {
    console.error("Failed to preload Google auth script:", error);
  });
};

export const requestGoogleAuthCode = async () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    throw new Error("Missing REACT_APP_GOOGLE_CLIENT_ID");
  }

  await loadGoogleScript();

  return new Promise((resolve, reject) => {
    const codeClient = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      scope: "openid email profile",
      ux_mode: "popup",
      callback: (response) => {
        if (response?.code) {
          resolve(response.code);
          return;
        }

        reject(new Error(response?.error || "Google did not return an auth code"));
      },
      error_callback: (error) => {
        reject(new Error(error?.message || error?.type || "Google sign in failed"));
      },
    });

    codeClient.requestCode();
  });
};
